import React from "react";
import MultiSelectDropdown from "../../../../../components/multiSelectDropdown/multiSelectDropdown";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/retentionSagas";

const CustomDateRanges = () => {
  const { filters, selectedFilters } = useSelector((state) => {
    const { filters, selectedFilters } = state.funnelRetention;
    return { filters, selectedFilters };
  }, shallowEqual);
  const dispatch = useDispatch();
  return (
    <MultiSelectDropdown
      filterType="Locations"
      options={filters}
      placeholder={"Select Offers"}
      numberDisplayed={0}
      maxSelect={6}
      maxSelected={(data) => dispatch(actionCreators.maxSelected(data))}
      enableMax={true}
      enableOnly={true}
      selectedFilters={selectedFilters}
      enableDefaultSelected={true}
      haveOnSelectChange={false}
      avoidSelectIfMaxSelected={true}
      updateLocations={(data) => dispatch(actionCreators.updateFilters(data))}
    />
  );
};
export default CustomDateRanges;
